<template>
    <div class="widget-area"> 
        <div class="widget widget_grin_posts_thumb">
            <h3 class="widget-title">{{ $t('sidebar_recent_posts') }}</h3>

            <div class="item">
                
                     
                    <h4 class="title usmall">
                       <router-link to="/why-we-lose-teeth">{{ $t('sidebar_implants_r1_title') }}</router-link>

                    </h4>
            </div>

            <div class="item">
             
                     
                    <h4 class="title usmall">
                        <router-link to="/hollywood-smile-longevity">{{ $t('sidebar_hollywoodsmile_two') }}</router-link>

                    </h4>
            </div>
            
            
        </div>
        <div class="widget widget_grin_posts_thumb">
            <h3 class="widget-title">{{ $t('sidebar_popular_posts') }}</h3>

            

            <div class="item">
               
                     
                    <h4 class="title usmall">
                     
                        <router-link to="/hollywood-smile-purpose">{{ $t('sidebar_hollywoodsmile_one') }}</router-link>

                    </h4>
            </div>

            

            <div class="item">
              
                     
                    <h4 class="title usmall">
                      
                        <router-link to="/daily-care">{{ $t('sidebar_implants_p3_title') }}</router-link>

                    </h4>
            </div>

            <div class="item">
                
                     
                    <h4 class="title usmall">
                        <router-link to="/after-surgery">
                            {{ $t('sidebar_implants_p4_title') }}
                        </router-link>
                    </h4>
            </div>
        </div>


    </div>
</template>

<script>
export default {
    name: 'BlogSidebarHollywoodSmile'
}
</script>